export * from './warehouse.component';